/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".teammember-img[_ngcontent-%COMP%]{width:65px;height:65px;padding:2px 10px 21px 33px}.panel-body[_ngcontent-%COMP%]{display:flex}.heading[_ngcontent-%COMP%]{display:flex;align-items:center}"];
export { styles as styles };
